import { Stack } from '@mui/material';
import React, { PropsWithChildren } from 'react';
import {
	listLeftOffset,
	sectionGap,
	stackedClassName,
	verticalGap
} from './mdConsts';

const MDList: React.FC<PropsWithChildren> = ({ children = null }) => (
	<Stack
		component="ul"
		data-testid="md-list"
		className={stackedClassName}
		gap={verticalGap}
		my={0}
		sx={{
			paddingInlineStart: listLeftOffset,
			[`:not(.${stackedClassName} > &)`]: {
				mt: sectionGap
			}
		}}
	>
		{children}
	</Stack>
);

export default MDList;
